module.exports = __webpack_public_path__ + "img/day3.accde76a.jpg";